module.exports = __webpack_public_path__ + "img/jhzh2.0bc6c57b.jpg";